module.exports = __webpack_public_path__ + "img/logo_text.fe3c99d7.png";